// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeSearchSidebar_searchSidebar__9QeK0 {
  background: #ffffff;
    width: 400px;
    max-width: 100%;
    height: 50vh;
    margin: 0 auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    direction: rtl;
    /* position: absolute; */
    right: 0;
    /* z-index: 1000; */
}

.TreeSearchSidebar_sidebarHeader__O8Ula {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.TreeSearchSidebar_sidebarTitle__mPkjx {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  flex: 1 1;
  text-align: center;
}

.TreeSearchSidebar_categoryIcon__eHA2y {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  overflow: hidden;
}

.TreeSearchSidebar_categoryIcon__eHA2y img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.TreeSearchSidebar_searchForm__bs4Nq {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.TreeSearchSidebar_searchInputContainer__-lSpb {
  position: relative;
  display: flex;
  gap: 8px;
}

.TreeSearchSidebar_searchInput__YCXCo {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  background: #f9fafb;
  transition: all 0.2s ease;
  outline: none;
  direction: rtl;
}

.TreeSearchSidebar_searchInput__YCXCo:focus {
  border-color: #1a5f3f;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 95, 63, 0.1);
}

.TreeSearchSidebar_searchInput__YCXCo::placeholder {
  color: #9ca3af;
}

.TreeSearchSidebar_searchButton__xfNoA {
  background: #1a5f3f;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
}

.TreeSearchSidebar_searchButton__xfNoA:hover {
  background: #0f4229;
  transform: translateY(-1px);
}

.TreeSearchSidebar_searchResults__fXezv {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px 0;
}

.TreeSearchSidebar_loadingState__XxneL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6b7280;
}

.TreeSearchSidebar_loadingSpinner__gqq1I {
  width: 24px;
  height: 24px;
  border: 3px solid #e5e7eb;
  border-top: 3px solid #1a5f3f;
  border-radius: 50%;
  animation: TreeSearchSidebar_spin__Yty2n 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes TreeSearchSidebar_spin__Yty2n {
  to {
    transform: rotate(360deg);
  }
}

.TreeSearchSidebar_noResults__gYWxj {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6b7280;
  text-align: center;
}

.TreeSearchSidebar_noResultsIcon__ThPvn {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.TreeSearchSidebar_noResults__gYWxj p {
  margin: 0 0 8px 0;
  font-weight: 500;
}

.TreeSearchSidebar_noResults__gYWxj small {
  opacity: 0.7;
}

.TreeSearchSidebar_resultsList__rcNXQ {
  padding: 0 10px;
}

.TreeSearchSidebar_resultItem__uMW9L {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  margin-bottom: 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.TreeSearchSidebar_resultItem__uMW9L:hover {
  background: #f8fafc;
  border-color: #e5e7eb;
  transform: translateX(-2px);
}

.TreeSearchSidebar_resultImage__9MJmP {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 8px;
  overflow: hidden;
  margin-left: 12px;
  flex-shrink: 0;
}

.TreeSearchSidebar_resultImage__9MJmP img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.TreeSearchSidebar_resultOverlay__yaBJ2 {
  position: absolute;
  bottom: 2px;
  right: 2px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 2px;
  backdrop-filter: blur(4px);
}

.TreeSearchSidebar_resultIcon__ryWW8 {
  width: 12px;
  height: 12px;
  object-fit: cover;
}

.TreeSearchSidebar_resultContent__aTlzw {
  flex: 1 1;
  min-width: 0;
}

.TreeSearchSidebar_resultTitle__a8vg\\+ {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 6px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.TreeSearchSidebar_resultMeta__7hyjI {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #6b7280;
}

.TreeSearchSidebar_resultAuthor__vlxRB {
  font-weight: 500;
}

.TreeSearchSidebar_resultDate__TxLy7 {
  opacity: 0.8;
}

.TreeSearchSidebar_moreResultsSection__bDMHR {
  padding: 20px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.TreeSearchSidebar_moreResultsButton__0IfRG {
  width: 100%;
  background: #1a5f3f;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.TreeSearchSidebar_moreResultsButton__0IfRG:hover {
  background: #0f4229;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);
}

.TreeSearchSidebar_moreResultsArrow__hFAxq {
  font-size: 16px;
  transition: transform 0.2s ease;
}

.TreeSearchSidebar_moreResultsButton__0IfRG:hover .TreeSearchSidebar_moreResultsArrow__hFAxq {
  transform: translateX(-2px);
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .TreeSearchSidebar_searchSidebar__9QeK0 {
    width: 100vw;
    position: relative;
    height: auto;
    min-height: 50vh;
  }
  
  .TreeSearchSidebar_sidebarHeader__O8Ula {
    padding: 15px;
  }
  
  .TreeSearchSidebar_sidebarTitle__mPkjx {
    font-size: 16px;
  }
  
  .TreeSearchSidebar_searchForm__bs4Nq {
    padding: 15px;
  }
  
  .TreeSearchSidebar_resultItem__uMW9L {
    padding: 10px;
  }
  
  .TreeSearchSidebar_resultTitle__a8vg\\+ {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Search bars/TreeSearchSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,wBAAwB;IACxB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,2DAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".searchSidebar {\r\n  background: #ffffff;\r\n    width: 400px;\r\n    max-width: 100%;\r\n    height: 50vh;\r\n    margin: 0 auto;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n    display: flex;\r\n    flex-direction: column;\r\n    direction: rtl;\r\n    /* position: absolute; */\r\n    right: 0;\r\n    /* z-index: 1000; */\r\n}\r\n\r\n.sidebarHeader {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sidebarTitle {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n  margin: 0;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.categoryIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.categoryIcon img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.searchForm {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.searchInputContainer {\r\n  position: relative;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.searchInput {\r\n  flex: 1;\r\n  padding: 12px 16px;\r\n  border: 2px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  font-size: 14px;\r\n  background: #f9fafb;\r\n  transition: all 0.2s ease;\r\n  outline: none;\r\n  direction: rtl;\r\n}\r\n\r\n.searchInput:focus {\r\n  border-color: #1a5f3f;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.searchInput::placeholder {\r\n  color: #9ca3af;\r\n}\r\n\r\n.searchButton {\r\n  background: #1a5f3f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 50px;\r\n}\r\n\r\n.searchButton:hover {\r\n  background: #0f4229;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.searchResults {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 10px 0;\r\n}\r\n\r\n.loadingState {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n  color: #6b7280;\r\n}\r\n\r\n.loadingSpinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid #e5e7eb;\r\n  border-top: 3px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.noResults {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n  color: #6b7280;\r\n  text-align: center;\r\n}\r\n\r\n.noResultsIcon {\r\n  font-size: 32px;\r\n  margin-bottom: 12px;\r\n  opacity: 0.5;\r\n}\r\n\r\n.noResults p {\r\n  margin: 0 0 8px 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.noResults small {\r\n  opacity: 0.7;\r\n}\r\n\r\n.resultsList {\r\n  padding: 0 10px;\r\n}\r\n\r\n.resultItem {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px 10px;\r\n  margin-bottom: 8px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.resultItem:hover {\r\n  background: #f8fafc;\r\n  border-color: #e5e7eb;\r\n  transform: translateX(-2px);\r\n}\r\n\r\n.resultImage {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  margin-left: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.resultImage img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.resultOverlay {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  right: 2px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border-radius: 4px;\r\n  padding: 2px;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.resultIcon {\r\n  width: 12px;\r\n  height: 12px;\r\n  object-fit: cover;\r\n}\r\n\r\n.resultContent {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.resultTitle {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #1f2937;\r\n  margin: 0 0 6px 0;\r\n  line-height: 1.4;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.resultMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n}\r\n\r\n.resultAuthor {\r\n  font-weight: 500;\r\n}\r\n\r\n.resultDate {\r\n  opacity: 0.8;\r\n}\r\n\r\n.moreResultsSection {\r\n  padding: 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n  background: #f8fafc;\r\n}\r\n\r\n.moreResultsButton {\r\n  width: 100%;\r\n  background: #1a5f3f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 14px 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.moreResultsButton:hover {\r\n  background: #0f4229;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.moreResultsArrow {\r\n  font-size: 16px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.moreResultsButton:hover .moreResultsArrow {\r\n  transform: translateX(-2px);\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 480px) {\r\n  .searchSidebar {\r\n    width: 100vw;\r\n    position: relative;\r\n    height: auto;\r\n    min-height: 50vh;\r\n  }\r\n  \r\n  .sidebarHeader {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .sidebarTitle {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .searchForm {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .resultItem {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .resultTitle {\r\n    font-size: 13px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchSidebar": `TreeSearchSidebar_searchSidebar__9QeK0`,
	"sidebarHeader": `TreeSearchSidebar_sidebarHeader__O8Ula`,
	"sidebarTitle": `TreeSearchSidebar_sidebarTitle__mPkjx`,
	"categoryIcon": `TreeSearchSidebar_categoryIcon__eHA2y`,
	"searchForm": `TreeSearchSidebar_searchForm__bs4Nq`,
	"searchInputContainer": `TreeSearchSidebar_searchInputContainer__-lSpb`,
	"searchInput": `TreeSearchSidebar_searchInput__YCXCo`,
	"searchButton": `TreeSearchSidebar_searchButton__xfNoA`,
	"searchResults": `TreeSearchSidebar_searchResults__fXezv`,
	"loadingState": `TreeSearchSidebar_loadingState__XxneL`,
	"loadingSpinner": `TreeSearchSidebar_loadingSpinner__gqq1I`,
	"spin": `TreeSearchSidebar_spin__Yty2n`,
	"noResults": `TreeSearchSidebar_noResults__gYWxj`,
	"noResultsIcon": `TreeSearchSidebar_noResultsIcon__ThPvn`,
	"resultsList": `TreeSearchSidebar_resultsList__rcNXQ`,
	"resultItem": `TreeSearchSidebar_resultItem__uMW9L`,
	"resultImage": `TreeSearchSidebar_resultImage__9MJmP`,
	"resultOverlay": `TreeSearchSidebar_resultOverlay__yaBJ2`,
	"resultIcon": `TreeSearchSidebar_resultIcon__ryWW8`,
	"resultContent": `TreeSearchSidebar_resultContent__aTlzw`,
	"resultTitle": `TreeSearchSidebar_resultTitle__a8vg+`,
	"resultMeta": `TreeSearchSidebar_resultMeta__7hyjI`,
	"resultAuthor": `TreeSearchSidebar_resultAuthor__vlxRB`,
	"resultDate": `TreeSearchSidebar_resultDate__TxLy7`,
	"moreResultsSection": `TreeSearchSidebar_moreResultsSection__bDMHR`,
	"moreResultsButton": `TreeSearchSidebar_moreResultsButton__0IfRG`,
	"moreResultsArrow": `TreeSearchSidebar_moreResultsArrow__hFAxq`
};
export default ___CSS_LOADER_EXPORT___;
